export default __webpack_public_path__ + "static/platforms-fc6288cc3eef3cfe3a0047bb1c185666.svg";